"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M5 4c-.5523 0-1 .4477-1 1v2c0 .5523.4477 1 1 1h1.625v2H5c-.5523 0-1 .4477-1 1v2c0 .5523.4477 1 1 1h1.625v2H5c-.5523 0-1 .4477-1 1v2c0 .5523.4477 1 1 1h1.625v2H5c-1.6568 0-3-1.3431-3-3v-2a2.989 2.989 0 0 1 .7639-2A2.9888 2.9888 0 0 1 2 13v-2a2.989 2.989 0 0 1 .7639-2A2.9888 2.9888 0 0 1 2 7V5c0-1.6568 1.3432-3 3-3h1.625v2H5zm14 0h-1.625V2H19c1.6569 0 3 1.3432 3 3v2a2.989 2.989 0 0 1-.7639 2A2.989 2.989 0 0 1 22 11v2a2.989 2.989 0 0 1-.7639 2A2.989 2.989 0 0 1 22 17v2c0 1.6569-1.3431 3-3 3h-1.625v-2H19c.5523 0 1-.4477 1-1v-2c0-.5523-.4477-1-1-1h-1.625v-2H19c.5523 0 1-.4477 1-1v-2c0-.5523-.4477-1-1-1h-1.625V8H19c.5523 0 1-.4477 1-1V5c0-.5523-.4477-1-1-1zm-7 3c.787 0 1.425-.5 1.425-1.5S12.787 4 12 4s-1.425.5-1.425 1.5S11.213 7 12 7zm-.0001 7.5L10.8888 21H9.2221l1.1111-7.5833v-3.25l-1.3053 3.7144-1.2735-.4599 1.5333-4.119A2 2 0 0 1 11.1621 8h1.6758a2 2 0 0 1 1.8743 1.3023l1.5333 4.1189-1.2735.4599-1.3053-3.7144v3.25L14.7778 21h-1.6667l-1.1112-6.5z"
  })];
};

exports.default = _default;